var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-materials',{attrs:{"title":"Formularios de Materiales","showActionCreate":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }